<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Bulk Add Dialog Popup Visibility</h5>
                <span class="modal-x-button" (click)="onCloseDialog()">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div class="modal-body">
                <div class="col-md-12 p-0">
                    <div class="col-12 p-0 mb-3 dialog-dropdown">
                        <label class="col-4 col-form-label control-label sub_tab_title p-0">Dialog Code <span class="text-danger">*</span></label>
                        <ng-container class="col-12">
                            <kt-dropdown-wo-lazyload 
                                [form]='form' 
                                [dropdownList]='popupDropdownList' 
                                [dropdownSettings]='popupDropdownListSettings' 
                                [formName]="'popup_id'" 
                                [selectionAttributes]="'id'" 
                                [selectedItems]="popupListSelectedItems">
                            </kt-dropdown-wo-lazyload>
                        </ng-container>
                    </div>
                    <div class="col-12 p-0 mb-3">
                        <label class="col-4 col-form-label control-label sub_tab_title p-0">Default<i class="fas fa-exclamation-circle" matTooltip="Check to apply the same visibility settings from Field Visibility." matTooltipClass="custom-tooltip" matTooltipHideDelay="0"></i></label>
                        <div class="custom-control custom-checkbox col-12 p-0">
                            <input type="checkbox" formControlName="is_default" id="is_default" (change)="onChangePopupDialogDefault($event)">
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="row col-4 col-form-label control-label sub_tab_title p-0">Visibility <span class="text-danger">*</span></label>
                        <div class="row">
                            <select class="col-3 form-control" formControlName="visibility" [ngClass]="form.value.is_default || (!form.value.is_default && (data.dialogPopupVisibilitySettings.dialog_popup_column_visibility != 1 && (form.value.visibility == 2 || form.value.visibility == 3))) ? 'disabled-select' : ''" (change)="onChangePopupDialogVisbility($event)">
                                <option value="null" disabled>Please Select</option>
                                <ng-container *ngIf="data.dialogPopupVisibilitySettings.dialog_popup_column_visibility != 1 || form.value.is_default">
                                    <option value="1">All</option>
                                </ng-container>
                                <option value="2">Include Selected</option>
                                <option value="3">Exclude Selected</option>
                            </select>
                            <ng-container *ngIf="form.value.visibility > 1">
                                <div class="col-9 pr-0" [ngClass]="{'is-invalid': !form.value.is_default && form.value.visibility != 1 && form.value.affiliate_id.length == 0 && form.value.visibility != null }">
                                    <div [ngClass]="{'div-disabled': form.value.is_default || form.value.visibility == null }">
                                        <kt-dropdown-wo-lazyload
                                            [form]='form'
                                            [dropdownList]='filteredAffiliateDropdownList'
                                            [dropdownSettings]='affiliateDropdownListSettings'
                                            [formName]="'affiliate_id'"
                                            [selectionAttributes]="'id'"
                                            [selectedItems]="affiliateListSelectedItems"
                                            (selectedItemsChanged)="onSelectedAffiliateDialogListItems($event)">>
                                        </kt-dropdown-wo-lazyload>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <ng-container *ngIf="canEditDialog">
                    <kt-submit-button [isDisabled]="!form.valid || affiliateListSelectedItems.length == 0" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
                </ng-container>
            </div>
        </div>
    </form>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event, true)"></kt-swal-alert>